import { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { CustomButton } from "../CustomButton";
import { classNames } from "primereact/utils";
import "./formStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { addCompany } from "../../reducers/customerSlice";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { InputTextarea } from "primereact/inputtextarea";
import Loader from "../../components/Loader";
import { Toast } from "primereact/toast";

// 2. POST https://api.skalebot.com/api/v1/company
// {
//     "companyName": "deskala",
//     "phone": 8852040690,
//     "personalPhone": 9085595690
//     "gstNumber": "123",
//     "panNumber": "234",
//     "billingAddress": "Bangalore"
// }
// 3. //PUT Company Request
// Update language, PhoneNumberId, whatsAppBusinessAccountID in company table
// https://developers.facebook.com/apps/1140950256592261/whatsapp-business/wa-dev-console/?business_id=683975392840248

function Company({ onHide }) {
  const dispatch = useDispatch();
  const { selectedcustomers, mode } = useSelector((state) => state.customer);
  const defaultValues = {
    companyName: mode === "update" ? selectedcustomers.companyName : "",
    phone: mode === "update" ? `+ ${selectedcustomers.phone}` : "",
    personalPhone: mode === "update" ? selectedcustomers.personalPhone : "",
    gstNumber: mode === "update" ? selectedcustomers.gstNumber : "",
    panNumber: mode === "update" ? selectedcustomers.panNumber : "",
    billingAddress: mode === "update" ? selectedcustomers.billingAddress : "",
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });

  //function form get error message
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const { loading } = useSelector((state) => state.customer);
  const toast = useRef(null);
  const onSubmit = (data) => {
    if (mode === "update") {
      toast.current.show({ severity: "error", detail: "Update Not Enabled" });
    } else {
      dispatch(addCompany({ data }))
        .unwrap()
        .then((res) => {
          toast.current.show({
            severity: "success",
            detail: "Company Added Succesfully",
          });
        })
        .catch((err) => {
          toast.current.show({ severity: "error", detail: err.message });
        });
    }
    onHide();
  };
  const modalLoad = () => {
    return <Loader visible={loading} />;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
      {modalLoad()}
      <Toast ref={toast} />
      <div className="field">
        <label htmlFor="companyName">Company Name*</label>
        <Controller
          name="companyName"
          control={control}
          rules={{ required: "Company Name is required." }}
          render={({ field, fieldState }) => (
            <InputText
              id={field.name}
              maxLength={24}
              className={classNames({ "p-invalid": fieldState.invalid })}
              placeholder="Enter your name here"
              {...field}
              disabled={mode === "update" ? true : false}
            />
          )}
        />
        {getFormErrorMessage("name")}
      </div>
      <div className="field">
        <label htmlFor="phone">Phone *</label>
        <Controller
          name="phone"
          control={control}
          rules={{
            required: "phone number is required.",
            // validate:value=> value.toString().length == 10 || "Please enter a valid phone number. "
            validate: (value) =>
              isValidPhoneNumber(value.toString()) ||
              "Please enter a valid phone number. ",
          }}
          render={({ field, fieldState }) => (
            <PhoneInputWithCountry
              name="phone"
              control={control}
              defaultCountry="IN"
              id={field.name}
              placeholder="Enter phone number"
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              className={classNames({ "p-invalid": fieldState.invalid })}
              {...field}
            />
          )}
        />
        {getFormErrorMessage("phone")}
      </div>
      <div className="field">
        <label htmlFor="personalPhone">Personal Phone *</label>
        <Controller
          name="personalPhone"
          control={control}
          rules={{
            required: "Personal phone number is required.",
            // validate:value=> value.toString().length == 10 || "Please enter a valid phone number. "
            validate: (value) =>
              isValidPhoneNumber(value.toString()) ||
              "Please enter a valid phone number. ",
          }}
          render={({ field, fieldState }) => (
            <PhoneInputWithCountry
              name="personalPhone"
              control={control}
              defaultCountry="IN"
              id={field.name}
              placeholder="Enter Phone Number"
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              className={classNames({ "p-invalid": fieldState.invalid })}
              {...field}
            />
          )}
        />
        {getFormErrorMessage("personalPhone")}
      </div>
      <div className="field">
        <label htmlFor="gstNumber">GST Number</label>
        <Controller
          name="gstNumber"
          control={control}
          rules={{
            required: false,
            pattern: {
              message: "Enter a GST Number",
            },
          }}
          render={({ field, fieldState }) => (
            <InputText
              id={field.name}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Enter GST Number here"
              className={classNames({ "p-invalid": fieldState.invalid })}
              {...field}
            />
          )}
        />
        {getFormErrorMessage("gstNumber")}
      </div>
      <div className="field">
        <label htmlFor="panNumber">Pan Number *</label>
        <Controller
          name="panNumber"
          control={control}
          rules={{
            required: false,
            pattern: {
              message: "Enter Pan Number",
            },
          }}
          render={({ field, fieldState }) => (
            <InputText
              id={field.name}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Enter Pan Number here"
              className={classNames({ "p-invalid": fieldState.invalid })}
              {...field}
            />
          )}
        />
        {getFormErrorMessage("panNumber")}
      </div>
      <div className="field">
        <label
          htmlFor="billingAddress"
          className={classNames({ "p-error": errors.name })}
        >
          Billing Address*
        </label>
        <Controller
          name="billingAddress"
          control={control}
          rules={{ required: "Please enter a Billing Address" }}
          render={({ field, fieldState }) => (
            <InputTextarea
              id={field.name}
              className={classNames({ "p-invalid": fieldState.invalid })}
              placeholder="Enter Billing Address"
              {...field}
              autoResize
            />
          )}
        />
        {getFormErrorMessage("billingAddress")}
      </div>
      <div>
        <CustomButton varient="filled" type="submit" label={"Save"} />
      </div>
    </form>
  );
}

export default Company;
